import React from "react";
import { useAPI } from "../../../lib/common";

export const GreenScreenBackgroundsContext = React.createContext([]);

export default ({ children, jobUuid }) => {
  const [backgrounds, loading] = useAPI(
    "/api/webshop/green-screen-backgrounds/" + jobUuid
  );

  return (
    <GreenScreenBackgroundsContext.Provider value={[backgrounds, loading]}>
      {children}
    </GreenScreenBackgroundsContext.Provider>
  );
};

export const useGreenScreenBackgrounds = () =>
  React.useContext(GreenScreenBackgroundsContext);
